import React from 'react';
import { useSiteMetadata } from 'staticQueries/use-site-metadata';
import { getApiUrl } from 'utils/environment';
import { replaceKeyword } from 'utils';
import {
  useGenerateHreflangs,
  generatePreloadFonts,
  getUrl,
  getLocalBusinessSchema,
} from './helpers';

const defaultConfig = {
  ogType: 'website',
  twitterType: 'summary_large_image',
  image:
    'https://static.andersenlab.com/andersenlab/new-andersensite/logos/andersen-preview-image.png',
  icon: {
    main32:
      'https://static.andersenlab.com/andersenlab/new-andersensite/favicon/full-pack/favicon-32x32.png',
    main16:
      'https://static.andersenlab.com/andersenlab/new-andersensite/favicon/full-pack/favicon-16x16.png',
  },
};

export default function SEO({ pathname, children, title, description, ...props }) {
  const { title: defaultTitle, description: defaultDescription } = useSiteMetadata();
  const hreflangs = useGenerateHreflangs(pathname);
  const config = {
    ...defaultConfig,
    ...props,
    title: replaceKeyword(title || defaultTitle),
    description: replaceKeyword(description || defaultDescription),
    url: getUrl(pathname),
  };

  return (
    <>
      <title>{config.title}</title>
      <meta name="description" content={config.description} />
      <meta property="og:title" content={config.title} />
      <meta property="og:description" content={config.description} />
      <meta property="og:type" content={config.ogType} />
      <meta property="og:url" content={config.url} />
      <meta property="og:image" content={config.image} />
      <meta property="twitter:title" content={config.title} />
      <meta property="twitter:description" content={config.description} />
      <meta property="twitter:card" content={config.twitterType} />
      <meta property="twitter:image" content={config.image} />
      <meta name="p:domain_verify" content="eadf1540286eae54a4f55e5d86b3f678" />
      {generatePreloadFonts()}
      <link rel="icon" type="image/png" sizes="32x32" href={config.icon.main32} />
      <link rel="icon" type="image/png" sizes="16x16" href={config.icon.main16} />
      <link rel="canonical" href={config.url} />
      <link rel="preconnect" href={`${getApiUrl()}/api/content/`} />
      <link rel="preconnect" href="https://www.googletagmanager.com" />
      <link rel="preconnect" href="https://snap.licdn.com" />
      <link rel="preconnect" href="https://www.clarity.ms" />
      <link rel="preconnect" href="https://sc.lfeeder.com" />
      <link rel="preconnect" href="https://bat.bing.com" />
      <link rel="preconnect" href="https://maps.googleapis.com" />
      <link rel="preconnect" href="https://googleads.g.doubleclick.net" />
      {hreflangs}
      <script key="LocalBusiness" type="application/ld+json">
        {getLocalBusinessSchema()}
      </script>
      {children}
    </>
  );
}
